import { ArrowRightOutlined } from '@ant-design/icons';
import {
  CollegamentoRichiestaDTOTipo,
  RichiestaDTO,
  TipoDomandaDTO,
} from '@framework/api-client';
import {
  LinkedSubmissionCard,
  SubmissionLinkLogic,
} from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import { VerticalSpace, generatePath, useHistory } from '@framework/ui';
import { Button, Typography } from 'antd';
import React from 'react';
const { Text, Title } = Typography;

export interface ISubmissionLinkedBoxProps {
  submission?: RichiestaDTO | null;
  inquiry?: TipoDomandaDTO | null;
}

/**
 * Banner di collegamento a una richiesta collegata per il frontoffice
 */
export function SubmissionLinkedBox(props: ISubmissionLinkedBoxProps) {
  const { submission, inquiry } = props;
  const history = useHistory();
  const { t } = useTranslation();
  if (!submission || !inquiry) return null;

  const hasLinkedInquiry = inquiry.tipoDomandaOsservata;
  const linkedSubmission = SubmissionLinkLogic.getFirstOutboundLink(
    submission.collegamenti,
    CollegamentoRichiestaDTOTipo.OSSERVAZIONE,
  );

  if (!linkedSubmission || !hasLinkedInquiry) return null;

  return (
    <div>
      <LinkedSubmissionCard
        dark
        action={
          <Button
            size="large"
            onClick={() => {
              history.push(
                generatePath('/area-pubblica/:id', {
                  id: linkedSubmission.idRichiesta ?? '',
                }),
              );
            }}
          >
            {t(
              'submission-linked-button.visualizza-richiesta',
              'Visualizza richiesta',
            )}{' '}
            <ArrowRightOutlined />
          </Button>
        }
        summary={linkedSubmission.tipo}
        linkedSubmissionId={linkedSubmission.idRichiesta}
        title={inquiry.tipoDomandaOsservata?.titolo ?? undefined}
      />
      <VerticalSpace size={16} />
    </div>
  );
}
